import { TStoriesVariant } from './types';
import { lazyLoad } from 'app/utils/loadable';

export const Stories = lazyLoad(
  () => import('./stories'),
  (module) => module.Stories
);

export type { TStoriesVariant };
